<template>
    <div class="mt20">
        <div class="one-title">照料情况</div>
        <avue-form ref="form" v-model="orderForm" :option="orderOption" @submit="handleSubmit" @error="error">
            <template slot="menuForm" v-if="!isDetail">
                <el-button type="primary" @click="goNextHandle(2)">上一步</el-button>
                <el-button type="primary" @click="goNextHandle(4)">下一步</el-button>
            </template>
        </avue-form>
        <div class="mt10 tac" v-if="isDetail">
            <el-button type="primary" size="mini" @click="goNextHandle(2)">上一步</el-button>
            <el-button type="primary" size="mini" @click="goNextHandle(4)">下一步</el-button>
        </div>
    </div>
</template>
<script>
import { add, update } from "@/api/archives/index";
export default {
    props: {
        data: {
            type: Object,
            default: {}
        },
        isDetail: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            orderForm: {},
            orderOption: {
                size:'mini',
                detail: this.isDetail,
                emptyBtn: false,
                submitText: '保存',
                labelWidth: 100,
                column: [{
                    labelWidth: 220,
                    label: '4、当事人是否愿意接收服务',
                    prop: 'isWilling',
                    type: 'checkbox',
                    dicUrl: "/api/blade-system/dict-biz/dictionary",
                    dicQuery: {
                        code: 'yes_no'
                    },
                    props: {
                        label: "dictValue",
                        value: "dictKey"
                    },
                    span: 24
                }, {
                    label: '填表社工',
                    prop: 'fillName',
                    rules: [{
                        required: true,
                        message: "请填写社工",
                        trigger: "blur"
                    }]
                }, {
                    label: "填表日期",
                    prop: "fillDay",
                    type: "date",
                    format: "yyyy-MM-dd",
                    valueFormat: "yyyy-MM-dd",
                    hide: true,
                    rules: [{
                        required: true,
                        message: "请选择填表日期",
                        trigger: "blur"
                    }],
                }]
            },
        }
    },
    watch: {
        data: {
            deep: true,
            handler(val) {
                this.orderForm = this.data
            }
        }
    },
    mounted() {
        this.orderForm = this.data
    },
    methods: {
        goNextHandle(num) {
            this.$emit("next", num)
        },
        handleSubmit(form, done, loading) {
            update(this.orderForm).then((res) => {
                // 获取新增数据的相关字段
                this.$message({
                    type: "success",
                    message: "操作成功!"
                });
                // 数据回调进行刷新
                this.$refs.form.resetForm();
                done();
                this.$emit("refresh", res.data.data.id || '')
            }, error => {
                done();
                window.console.log(error);
            });
        },
        error(err) {
            this.$message.success('请填写完整信息');
        }
    }
}

</script>
<style lang="scss" scoped="scoped">
@import "@/styles/moudles/desk.scss";

</style>
<style lang="scss" scoped="scoped">
.one-title {
    padding: 30px 0;
    font-size: 20px;
    text-align: center;
}

</style>
